import { Controller } from "@hotwired/stimulus"

// Capa ambiental: siluetas dibujadas a mano (gemas, destellos, garabatos)
// que cruzan la pantalla de derecha a izquierda. Ligero y no bloquea clics.
export default class extends Controller {
  static values = {
    count: { type: Number, default: 14 },
    ink:   { type: String, default: "#0a0a0a" },
    gold:  { type: String, default: "#9a7a45" },
  }

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
    const rand = (a, b) => a + Math.random() * (b - a)
    const shapes = this.shapes()

    for (let i = 0; i < this.countValue; i++) {
      const el = document.createElement("div")
      el.className = "sketch"
      const stroke = Math.random() < 0.35 ? this.goldValue : this.inkValue
      const w = rand(1.6, 2.4).toFixed(1)
      el.style.setProperty("--top",   rand(-5, 100).toFixed(0) + "vh")
      el.style.setProperty("--size",  rand(14, 30).toFixed(0) + "px")
      el.style.setProperty("--dur",   rand(16, 34).toFixed(1) + "s")
      el.style.setProperty("--sway",  rand(3, 6).toFixed(1) + "s")
      el.style.setProperty("--delay", "-" + rand(0, 34).toFixed(1) + "s")
      el.style.setProperty("--bob",   rand(10, 30).toFixed(0) + "px")
      el.style.setProperty("--rot-a", rand(-30, 30).toFixed(0) + "deg")
      el.style.setProperty("--rot-b", rand(120, 340).toFixed(0) + "deg")
      el.style.setProperty("--op",    rand(0.16, 0.4).toFixed(2))
      el.innerHTML = `<div class="sway">${shapes[(Math.random() * shapes.length) | 0](stroke, w)}</div>`
      this.element.appendChild(el)
    }
  }

  disconnect() {
    this.element.innerHTML = ""
  }

  shapes() {
    const wrap = (inner, s, w) =>
      `<svg viewBox="0 0 40 40" fill="none" stroke="${s}" stroke-width="${w}" stroke-linecap="round" stroke-linejoin="round">${inner}</svg>`
    return [
      // Gema / diamante (guiño a Ruby)
      (s, w) => wrap(`<path d="M8 15 L14 6 H26 L32 15 L20 35 Z"/><path d="M8 15 H32 M14 6 L20 15 L26 6 M20 15 L20 35"/>`, s, w),
      // Destello / chispa
      (s, w) => wrap(`<path d="M20 6 C21 15 25 19 34 20 C25 21 21 25 20 34 C19 25 15 21 6 20 C15 19 19 15 20 6 Z"/>`, s, w),
      // Garabato / onda
      (s, w) => wrap(`<path d="M5 24 C10 14 14 14 19 22 C24 30 28 30 35 18"/>`, s, w),
      // Círculo dibujado
      (s, w) => wrap(`<path d="M20 6 C31 6 35 14 34 21 C33 30 25 35 18 34 C9 33 5 24 7 17 C9 10 13 7 20 6 Z"/>`, s, w),
      // Asterisco / estrella simple
      (s, w) => wrap(`<path d="M20 7 V33 M9 13 L31 27 M31 13 L9 27"/>`, s, w),
    ]
  }
}
